import React, { ChangeEvent } from "react";
import styled from "styled-components";
import { COLORS } from "../../constants/colors";
import { Input } from 'antd';
import 'antd/dist/antd.css';


interface Props {
    Icon: React.ReactNode;
    placeholder: string;
    active: boolean;
    props?: any;
    onChange: any;
    name: string;
    value: string;
}


const InputWrapper = styled.div<any>`
    display: flex;
    border-bottom: 1px solid  ${(props) => props.color};
    align-items: center;
    ${(props) => !props.active && {
        opacity: 0.5
    }}

    ${(props) => props.active && `
       .ant-input-affix-wrapper .anticon svg:hover {
             opacity: 1;
        }       
    `}

    ${(props) => !props.value && `
        :hover .icon{
             animation: slideIn 0.4s linear;
        }    
    `}


    @keyframes slideIn {
        0% {
            opacity: 0;
            margin-left: 20%;
        }

        100% {
            opacity: 1;
            margin-left: 0%;
        }

    }

    .ant-input-affix-wrapper {
        border: none;
        outline: none;
        background-color: transparent;
        padding: 4%;
    }

     .ant-input-affix-wrapper .ant-input::placeholder {
        color: ${(props) => props.placeholdercolor};
        font-weight: 300;
        opacity: 0.7;
    }

    input{
        background-color: ${COLORS.transparent_color1} !important;
        border: none;
        outline: none !important;
        width: 100%;
        padding: 4%;
        font-size: 1em;
        font-weight: 300;
        color: ${(props) => props.color} !important;
    }


    input:disabled {
        background-color: ${COLORS.transparent_color1};
        color: ${(props) => props.color};
    }


    .ant-input-affix-wrapper .anticon svg {
        color: ${(props) => props.color};
        opacity: 0.7;
    }
    .input::placeholder {
        color: ${(props) => props.placeholdercolor};
        font-weight: 300;
        opacity: 0.7;
    }

    .icon {
        color: ${(props) => props.color};
    }

 `;

const TextBorderLess = ({ Icon, placeholder, active, props, onChange, value, name }: Props): JSX.Element => {

    return (
        <InputWrapper color={COLORS.white_color1} placeholdercolor={COLORS.blue_inactive(1)} active={active} value={value}>
            <nav className="icon">{Icon}</nav>
            {props.type === 'password'
                ? <Input.Password name={name} onChange={onChange} value={value} {...props} disabled={active ? false : true} className="input" placeholder={placeholder} />
                : <Input autoComplete="off" name={name}  {...props} onChange={onChange} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} />
            }

        </InputWrapper>
    )
}


export default TextBorderLess;